import { createFileRoute, useParams } from '@tanstack/react-router';
import { FillScreen, VStack } from '@/components/Layout';
import BasicCard from './-component/BasicCard';
import CategoryPermissionDataTableCard from './-component/CategoryPermissionDataTableCard';
import HeaderDetailRole from './-component/HeaderDetailProductPermission';
import PeopleGroupDataTableCard from './-component/PeopleGroupDataTableCard';
import ProductPermissionDataTableCard from './-component/ProductPermissionDataTableCard';
import useGetRoleDetail from './-query/useGetRoleDetail';
export const Route = createFileRoute('/_staff/settings/permission-and-roles/_detail/roles/$id/')({
  component: RouteComponent
});
function RouteComponent() {
  const {
    id: roleId
  } = useParams({
    from: '/_staff/settings/permission-and-roles/_detail/roles/$id/'
  });
  const {
    data,
    isPending
  } = useGetRoleDetail({
    roleId
  });
  return <VStack>
      <HeaderDetailRole data={data} />

      <FillScreen className="flex flex-col gap-7 p-10">
        <BasicCard data={data} />

        <PeopleGroupDataTableCard data={data?.peopleGroups ?? []} isPending={isPending} />

        <ProductPermissionDataTableCard data={data} isPending={isPending} />

        <CategoryPermissionDataTableCard data={data?.categoryFieldAccessPermissions ?? []} isPending={isPending} />
      </FillScreen>
    </VStack>;
}